export const mapToLabelValue = <
  T extends Record<string, any>,
  L extends keyof T,
  V extends keyof T
>(
  data: T[],
  labelKey: L = 'value' as L,
  valueKey: V = 'key' as V
): { label: string; value: string | number }[] => {
  return Array.isArray(data)
    ? data.map((item) => ({
        label: String(item[labelKey]),
        value: item[valueKey],
      }))
    : [];
};